import { render, staticRenderFns } from "./_projectId.vue?vue&type=template&id=8f8a76c6&scoped=true"
import script from "./_projectId.vue?vue&type=script&lang=js"
export * from "./_projectId.vue?vue&type=script&lang=js"
import style0 from "./_projectId.vue?vue&type=style&index=0&id=8f8a76c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8a76c6",
  null
  
)

export default component.exports